import React from 'react';

import './FieldValidationMessage.css';
import clsx from 'clsx';

export type FieldValidationMessageProps = {
	id: string;
	errorMessage?: string;
	acceptanceTestTargetId?: string;
	className?: string;
};

export const FieldValidationMessage = ({
	errorMessage,
	id,
	className,
	acceptanceTestTargetId,
}: FieldValidationMessageProps) => (
	<span
		aria-atomic="true"
		aria-label={errorMessage ? `There is a problem with a field: ${errorMessage}` : undefined}
		className={clsx('validation-error-message', className)}
		data-pp-at-target={acceptanceTestTargetId}
		id={id}
		role="alert"
	>
		{errorMessage || ''}
	</span>
);
